import React, { memo, useMemo } from 'react'
import * as Styled from './styled'
import { ACTION_BUTTONS_CLASS_NAME } from 'consts'
import { useTimelineButtons, IButtonData } from './hooks/use-timeline-buttons'
import { ContextMenu } from 'common-components'

const getVisibleButtons = (buttons: IButtonData[]) => {
  return buttons.filter(button => button.isVisible)
}
const ActionButtons = () => {
  const { primaryButtons, secondaryButtons } = useTimelineButtons()

  const visiblePrimaryButtons = useMemo(
    () => getVisibleButtons(primaryButtons),
    [primaryButtons]
  )
  const visibleSecondaryButtons = useMemo(
    () => getVisibleButtons(secondaryButtons),
    [secondaryButtons]
  )

  return (
    <Styled.ActionButtons className={ACTION_BUTTONS_CLASS_NAME}>
      {visiblePrimaryButtons.map((button, index) => (
        <React.Fragment key={button.key}>
          {index > 0 && <Styled.Divider />}
          {button.component}
        </React.Fragment>
      ))}
      {!!visibleSecondaryButtons.length && (
        <>
          <Styled.Divider key={`secondary-buttons-divider`} />
          <ContextMenu
            size="small"
            wrapped={false}
            actions={visibleSecondaryButtons}
            flyoutOptions={{
              position: 'bottom',
              alignmentX: 'left',
              extraOffset: 5
            }}
          />
        </>
      )}
    </Styled.ActionButtons>
  )
}

export default memo(ActionButtons)
